import { render, staticRenderFns } from "./Seating.vue?vue&type=template&id=09718970&scoped=true&"
import script from "./Seating.vue?vue&type=script&lang=js&"
export * from "./Seating.vue?vue&type=script&lang=js&"
import style0 from "./Seating.vue?vue&type=style&index=0&id=09718970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09718970",
  null
  
)

export default component.exports